import { NestedSearch } from '@habity/types';
import { omitNullKeys } from '@habity/utils';

export const constructLocationsFromFilters = (
  filters: Partial<NestedSearch> | null
): TODO => {
  if (!omitNullKeys(filters) === null) return [];

  if (
    !filters?.label ||
    Array.isArray(filters.label)
  ) {
    return [];
  }

  // Check if we have any ID-based filters or coordinate-based filters
  const hasIdFilters = filters.areaIds || filters.municipalityIds || filters.brokerIds || filters.streetIds;
  const hasCoordinateFilters = filters.latitude && filters.longitude;

  if (!hasIdFilters && !hasCoordinateFilters) {
    return [];
  }

  const locations = filters?.label?.split(',').map((item) => {
    const [type, id, name] = item?.split(':');
    return {
      type,
      id: parseInt(id),
      name,
      label: name,
    };
  });

  return locations
    .map((location) => {
      switch (location.type) {
        case 'broker':
          if (!filters.brokerIds?.includes(location.id)) {
            console.warn('Broker ID mismatch');
            return null;
          }
          return location;

        case 'area':
          if (!filters.areaIds?.includes(location.id)) {
            console.warn('Area ID mismatch');
            return null;
          }
          return location;

        case 'municipality':
          if (!filters.municipalityIds?.includes(location.id)) {
            console.warn('Municipality ID mismatch');
            return null;
          }
          return location;

        case 'street':
          if (!filters.streetIds?.includes(location.id)) {
            console.warn('Street ID mismatch');
            return null;
          }
          return location;

        // Address type is used for coordinate-based searches (e.g., from speculators flow)
        case 'address':
          if (!hasCoordinateFilters) {
            console.warn('Address type requires latitude/longitude');
            return null;
          }
          return location;

        default:
          console.warn('Unknown location type:', location.type);
          return null;
      }
    })
    .filter(Boolean);
};
